export default "/fonts/lato-light-webfont.woff2?29cb3d0d704063cae6c05aafdb49ba70";